/**
 * Technical specification tables for quotation products.
 * Each spec has: id, label, headers, data (rows with Parameter, Value).
 * Keys match mainProductConfig / quotationFormConfig for form integration.
 */
import {
  recovery_booth_pollution_free as recoveryBoothContent,
  pre_treatment_process_steps,
  GEMA_Automatic_System,
} from './quotation_other_content.js';

const DEFAULT_HEADERS = ['Parameter', 'Value'];


// OVENS
const powder_coating_curing_oven = {
  id: 'powder_coating_curing_oven',
  label: 'Powder Coating Curing Oven',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Oven Size (LxWxH)', Value: '11800 x 5175 x 2625 mm' },
    { Parameter: 'MOC', Value: '1.2mm, 2mm, 3mm, 5mm, 8mm, 12mm MS With steel painted' },
    { Parameter: 'Oven Height from Ground', Value: '2560 mm' },
    { Parameter: 'Heat Exchanger', Value: 'Tube Type Indirect fire' },
    { Parameter: 'Heat Exchanger MOC', Value: 'SS-304 3mm & 2mm' },
    { Parameter: 'Operating Temperature', Value: '185 deg C' },
    { Parameter: 'Oven Heat Load', Value: '3,50,000 Kcal/hr' },
    { Parameter: 'Burner Capacity', Value: 'Max Gas 500 (LPG Fired)' },
    { Parameter: 'Burner Make', Value: 'EcoFlame' },
    { Parameter: 'Max Component Size', Value: '2000 x 1000 x 1250 mm' },
    { Parameter: 'Oven Type', Value: 'Camel Back' },
    { Parameter: 'Wall Thickness', Value: '150 mm' },
    { Parameter: 'Rockwool Grade', Value: '96 density' },
    { Parameter: 'Oven Entry Exit Size', Value: '1200 (W) x 5000 (L)' },
    { Parameter: 'Blower Capacity', Value: '50000 CMH (Dustech Make)' },
    { Parameter: 'Motor for Blower', Value: '20 HP 2 no\'s' },
  ],
};

const batch_type_oven = {
  id: 'batch_type_oven',
  label: 'Batch Type Oven',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Type of Application', Value: 'Manual Oven' },
    { Parameter: 'No. of Enclosure', Value: '01 Nos' },
    { Parameter: 'Trolley Weight', Value: '1000 kg' },
    { Parameter: 'Production', Value: '-' },
    { Parameter: 'Oven Size (LxWxH)', Value: '6150 x 4050 x 3200 mm (approx.)' },
    { Parameter: 'Trolley Size (LxWxH)', Value: '5600 x 3200 x 2534 mm (approx.)' },
    { Parameter: 'Material of Construction', Value: 'Oven in GI (1.25 mm thick) with MS base & support structure; Heat Exchanger: SS-304 (3 mm)' },
    { Parameter: 'Blower Capacity', Value: '35000 m³/hr, 15 HP Motor (ABB Make)' },
    { Parameter: 'Heat Load', Value: '1,30,000 kcal/hr' },
    { Parameter: 'Burner', Value: 'Max Gas 170 (Ecoflam Make)' },
    { Parameter: 'Gas Consumption', Value: '7 kg/hr' },
    { Parameter: 'Curing Schedule', Value: '10 min @ 180°C' },
    { Parameter: 'No. of Trolleys', Value: '02 Nos' },
    { Parameter: 'Design Temperature', Value: '180°C' },
    { Parameter: 'Temperature Accuracy', Value: '± 5°C' },
    { Parameter: 'Temperature Controller Type', Value: 'PID Controllers (L&T Make)' },
    { Parameter: 'Air Circulation Blower', Value: '01 No' },
    { Parameter: 'Air Circulation Rate', Value: '3 circulations/min' },
    { Parameter: 'Insulation', Value: '96 density' },
    { Parameter: 'Finish Paint Inside', Value: 'Silver (450°C capacity)' },
    { Parameter: 'Finish Paint Outside', Value: 'Primer + Synthetic Enamel Paint' },
    { Parameter: 'Explosion Door', Value: 'Roof cutout provided for excess air release' },
    { Parameter: 'Oven Doors', Value: 'Manually operated doors on both sides' },
  ],
};

const conveyorised_camel_back_water_drying_oven = {
  id: 'conveyorised_camel_back_water_drying_oven',
  label: 'Conveyorised Camel Back Water Drying Oven',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Quantity', Value: '01 Set' },
    { Parameter: 'Process', Value: 'Water Drying Oven' },
    { Parameter: 'Type', Value: 'Camel Back Oven' },
    { Parameter: 'Heating Source', Value: 'Gas Fired System' },
    { Parameter: 'Design Temperature', Value: '150 °C' },
    { Parameter: 'Working Temperature', Value: '130 °C' },
    { Parameter: 'Temperature Controller', Value: 'Digital single set point ON/OFF with PT-100 sensor' },
    { Parameter: 'Heating Zone Length', Value: '5580 mm (approx.)' },
    { Parameter: 'Overall Size (LxWxH)', Value: '10500 x 3000 x 3315 mm (approx.)' },
    { Parameter: 'Curing Schedule', Value: '10 min @ 130 °C (Pass only)' },
    { Parameter: 'Construction Type', Value: 'Male-Female type GI insulated panels with stiffeners' },
    { Parameter: 'Panel Thickness', Value: '1.2 mm' },
    { Parameter: 'Residence Time', Value: '10 min @ 1.5 m/min speed' },
    { Parameter: 'Thermal Insulation', Value: '150 mm Rockwool (96 kg/m³ density) with silicon sealant at joints' },
    { Parameter: 'Heat Exchanger Location', Value: 'Bottom of Oven' },
    { Parameter: 'Heat Exchanger Type', Value: 'Indirect Fired' },
    { Parameter: 'Heat Exchanger MOC', Value: 'SS-304' },
    { Parameter: 'Initial Heat Load', Value: '1,75,000 Kcal/hr' },
    { Parameter: 'Running Heat Load', Value: '1,50,000 Kcal/hr' },
    { Parameter: 'Burner Capacity', Value: 'As per final design' },
    { Parameter: 'Burner Make', Value: 'Ecoflame' },
    { Parameter: 'Hot Air Circulation Fan', Value: 'Reverse blade, V-belt driven with casing for directional airflow' },
    { Parameter: 'HAC Fan Capacity', Value: '27,000 CMH, 70 mm head, 01 Nos' },
    { Parameter: 'Air Delivery Duct', Value: 'Bottom-mounted with louvers for uniform air distribution' },
    { Parameter: 'Fresh Air Filter', Value: '01 Nos' },
    { Parameter: 'Filter Type', Value: 'Glass Wool Filter' },
    { Parameter: 'Air Entry Type', Value: 'From bottom of oven' },
    { Parameter: 'Exhaust Canopy', Value: '02 Nos' },
    { Parameter: 'Canopy Blower Capacity', Value: '1500 CMH' },
    { Parameter: 'Safety Interlock', Value: 'Provided for blower & burner' },
    { Parameter: 'Painting', Value: 'Primer + Synthetic Enamel Paint' },
  ],
};

const batch_type_water_dry_off_oven = {
  id: 'batch_type_water_dry_off_oven',
  label: 'Batch Type Water Dry-Off Oven',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Oven Size (LxWxH)', Value: '2500 x 2400 x 1600 mm' },
    { Parameter: 'MOC', Value: 'MS 2, 3 & 5 mm; Base Support: MS 3 mm & 5 mm' },
    { Parameter: 'Heat Required', Value: '50,000 kcal/hr' },
    { Parameter: 'Exhaust Blower Capacity', Value: '6000 CMH' },
    { Parameter: 'Motor Rating', Value: '5 HP, 3 Phase (ABB Make), 01 No' },
    { Parameter: 'Burner', Value: 'Max Gas 70 (Ecoflam Make)' },
    { Parameter: 'Wall Thickness', Value: '100 mm' },
    { Parameter: 'Insulation', Value: 'Rockwool, 96 density' },
    { Parameter: 'Door Type', Value: 'Motorized' },
  ],
};

const wood_sublimation_oven_plc_based = {
  id: 'wood_sublimation_oven_plc_based',
  label: 'Wood Sublimation Oven (PLC Based)',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Type of Application', Value: 'Fully Automated PLC Based Sublimation Oven' },
    { Parameter: 'No. of Enclosure', Value: '01 Nos' },
    { Parameter: 'Max Component Weight', Value: '5 kg' },
    { Parameter: 'Largest Component Size (LxWxH)', Value: '7000 x 50 x 50 mm' },
    { Parameter: 'Smallest Component Size (LxWxH)', Value: '2500 x 1250 x 150 mm' },
    { Parameter: 'Components per Trolley', Value: '36 pcs (12 x 3)' },
    { Parameter: 'Production', Value: '72 pcs/hr' },
    { Parameter: 'Max Trolley Load', Value: '60 kg' },
    { Parameter: 'Oven Size (LxWxH)', Value: '8000 x 2464 x 3304 mm (approx.)' },
    { Parameter: 'Trolley Size (LxWxH)', Value: '7600 x 1864 x 800 mm (approx.)' },
    { Parameter: 'Material of Construction', Value: 'MS (1.25, 2, 3 & 5 mm) with MS base & support structure' },
    { Parameter: 'Blower Capacity', Value: '11,000 m³/hr, 5 HP Motor (ABB Make)' },
    { Parameter: 'Heat Load', Value: '1,10,000 kcal/hr' },
    { Parameter: 'Burner', Value: 'Gas Fired, Max Gas 170 (Ecoflame Make)' },
    { Parameter: 'Gas Consumption', Value: '6–8 kg/hr' },
    { Parameter: 'Curing Schedule', Value: '18 min @ 180°C' },
    { Parameter: 'No. of Trolleys', Value: '02 Nos' },
    { Parameter: 'Installation Area Required', Value: '24500 x 3000 x 4000 mm' },
    { Parameter: 'Heat Exchanger', Value: 'Indirect Fired (Tube Type)' },
    { Parameter: 'Heat Exchanger MOC', Value: 'SS-304, 3 mm thickness' },
    { Parameter: 'Doors', Value: 'Pneumatic Controlled Automatic Sliding Door' },
    { Parameter: 'Exhaust Ducting', Value: 'As per site condition' },
  ],
};
const wood_sublimation_oven_without_plc = {
  id: 'wood_sublimation_oven_without_plc',
  label: 'Wood Sublimation Oven Without PLC',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Type of Application', Value: 'Controller Based Sublimation Oven' },
    { Parameter: 'No. of Enclosure', Value: '01 Nos' },
    { Parameter: 'Max Component Weight', Value: '5 kg' },
    { Parameter: 'Largest Component Size (LxWxH)', Value: '7000 x 50 x 50 mm' },
    { Parameter: 'Smallest Component Size (LxWxH)', Value: '2500 x 1250 x 150 mm' },
    { Parameter: 'Components per Trolley', Value: '36 pcs (12 x 3)' },
    { Parameter: 'Production', Value: '72 pcs/hr' },
    { Parameter: 'Max Trolley Load', Value: '60 kg' },
    { Parameter: 'Oven Size (LxWxH)', Value: '8000 x 2464 x 3304 mm (approx.)' },
    { Parameter: 'Trolley Size (LxWxH)', Value: '7600 x 1864 x 800 mm (approx.)' },
    { Parameter: 'Material of Construction', Value: 'MS (1.25, 2, 3 & 5 mm) with MS base & support structure' },
    { Parameter: 'Blower Capacity', Value: '11,000 m³/hr, 5 HP Motor (ABB Make)' },
    { Parameter: 'Heat Load', Value: '1,10,000 kcal/hr' },
    { Parameter: 'Burner', Value: 'Gas Fired, Max Gas 170 (Ecoflame Make)' },
    { Parameter: 'Gas Consumption', Value: '6–8 kg/hr' },
    { Parameter: 'Curing Schedule', Value: '18 min @ 180°C' },
    { Parameter: 'No. of Trolleys', Value: '02 Nos' },
    { Parameter: 'Installation Area Required', Value: '24500 x 3000 x 4000 mm' },
    { Parameter: 'Heat Exchanger', Value: 'Indirect Fired (Tube Type)' },
    { Parameter: 'Heat Exchanger MOC', Value: 'SS-304, 3 mm thickness' },
    { Parameter: 'Doors', Value: 'Pneumatic Controlled Automatic Sliding Door' },
    { Parameter: 'Exhaust Ducting', Value: 'As per site condition' },
  ],
};

// Booth
const common_booth_specifications = {
  id: 'all_booth',
  label: 'All Booth',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Quantity', Value: '01 Set' },
    { Parameter: 'Booth Size (LxWxH)', Value: '5000 x 1500 x 4954 mm' },
    { Parameter: 'Booth MOC', Value: 'SS-304 (1.5 mm, 2.0 mm, 2B Finish)' },
    { Parameter: 'Base & Support Structure', Value: 'MS (1.2 mm, 2.0 mm, 3.0 mm) Powder Coated' },
    { Parameter: 'Entry & Exit Cutout', Value: '500 (W) x 3210 (H) mm' },
    { Parameter: 'Operator Cutouts', Value: '02 Nos' },
    { Parameter: 'Reciprocator Cutouts', Value: '04 Nos' },
  ],
};

const booth_with_reciprocator_cutout = common_booth_specifications;
const four_manual_cutouts = common_booth_specifications;
const two_manual_cutouts = common_booth_specifications;
const single_operator = common_booth_specifications;
const jumbo = common_booth_specifications;

const liquid_painting_booth = {
  id: 'liquid_painting_booth',
  label: 'Liquid Paint Booth',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Type of Application', Value: 'Manual Single Operator' },
    { Parameter: 'No. of Enclosure', Value: '01 Nos' },
    { Parameter: 'Filter System', Value: 'Glass Filters & Paper Filters (Glass Fiber Paint Arrestor Media + Cardboard/Paper Filter Media)' },
    { Parameter: 'Window Size (WxH)', Value: '1580 x 2000 mm (approx.)' },
    { Parameter: 'Booth Size (DxWxH)', Value: '1550 x 1580 x 3300 mm (approx.)' },
    { Parameter: 'Material of Construction', Value: 'MS, 1.25 mm thick with MS base & support structure' },
    { Parameter: 'Exhaust Blower Location', Value: 'Top of Liquid Paint Booth Unit' },
    { Parameter: 'Exhaust Blower Capacity', Value: '4000 CMH' },
    { Parameter: 'Motor', Value: '5 HP (ABB Make)' },
    { Parameter: 'Illumination', Value: '600–800 Lux' },
  ],
};

const cartridge_filter_booth = {
  id: 'cartridge_filter_booth',
  label: 'Cartridge Filter Booth',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Booth Type', Value: 'Cartridge Filter Type' },
    { Parameter: 'Booth Size (DxWxH)', Value: '1800 x 1500 x 2300 mm' },
    { Parameter: 'Required Air Volume', Value: '2000 CMH' },
    { Parameter: 'No. of Cartridge Filters', Value: '02 Nos' },
    { Parameter: 'Cartridge Filter Size', Value: 'Ø320 x 600 mm' },
    { Parameter: 'Dust Collector MOC', Value: 'MS (2, 3, 5 mm) Steel Painted' },
    { Parameter: 'Cartridge Cleaning', Value: 'Purging System' },
    { Parameter: 'No. of Solenoid Valves', Value: '02 Nos' },
    { Parameter: 'Max Hanger Size (WxH)', Value: '1100 x 1100 mm' },
    { Parameter: 'Suction Motor', Value: '3 HP, 1 Unit, 2800 RPM (ABB Make)' },
    { Parameter: 'Operator Cutout', Value: '01 No' },
  ],
};

// Dust Collector
const dust_collector = {
  id: 'dust_collector',
  label: 'Dust Collector',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Entry & Exit Cutout (WxH)', Value: '700 x 1100 mm' },
    { Parameter: 'Component Size (LxWxH)', Value: '-' },
    { Parameter: 'Dust Collector Size (LxWxH)', Value: '1500 x 1500 x 4200 mm' },
    { Parameter: 'Motor', Value: '15 HP, 01 No' },
    { Parameter: 'Material of Construction', Value: 'MS (2.0, 3.0, 5.0, 12 mm) Steel Painted' },
    { Parameter: 'Electrical Cabinet', Value: '01 No' },
    { Parameter: 'Ducting', Value: 'MS Ducting as per final drawing' },
    { Parameter: 'Suction Type', Value: 'Single Point' },
    { Parameter: 'Exhaust Air Filters', Value: '04 Nos' },
    { Parameter: 'Cyclone Size (LxWxH)', Value: '1000 x 1000 x 4200 mm' },
    { Parameter: 'Duct Size', Value: 'As per given layout' },
  ],
};

// Powder Transfer System
const powder_transfer_system = {
  id: 'powder_transfer_system',
  label: 'Scope of Supply with Vibratory Sieve Machine',
  headers: ['Component', 'Quantity'],
  data: [
    { Parameter: 'Vibratory Sieve', Value: '01 Set' },
    { Parameter: 'Mesh size 300 microns', Value: '01 Nos' },
    { Parameter: 'Powder Transfer Pump', Value: '01 Nos' },
    { Parameter: 'MS Powder Hopper 100 Lit', Value: '01 Nos' },
    { Parameter: 'Hopper Trolley', Value: '01 Nos' },
    { Parameter: 'Small FRL', Value: '03 Nos' },
    { Parameter: 'Powder Transfer Hose', Value: 'As per requirement' },
    { Parameter: '8mm PU Pipe with Connector', Value: 'As per requirement' },
  ],
};



const over_head_conveyor = {
  id: 'over_head_conveyor',
  label: 'Over Head Conveyor',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Conveyor Type', Value: '7T Enclosed' },
    { Parameter: 'Load Capacity', Value: '60 kg per hook' },
    { Parameter: 'Chain Pitch', Value: '100 mm' },
    { Parameter: 'Hanging Pitch', Value: '200 mm' },
    { Parameter: 'Horizontal Radius', Value: '1000 mm' },
    { Parameter: 'Vertical Radius', Value: '800 mm' },
    { Parameter: 'Drive', Value: '2 HP 1 no\'s' },
    { Parameter: 'Lubrication Unit', Value: '1 no\'s' },
    { Parameter: 'Take Up Unit (Screw Type)', Value: '1 no\'s' },
    { Parameter: 'Conveyor Speed', Value: '1 m/min' },
    { Parameter: 'Conveyor inside Oven', Value: '24 mtr' },
    { Parameter: 'Total Conveyor', Value: '100 mtr approx' },
  ],
};

const recovery_booth_pollution_free = {
  id: 'recovery_booth_pollution_free',
  label: 'Recovery Booth (Pollution Free)',
  headers: DEFAULT_HEADERS,
  data: [
    { Parameter: 'Booth Size (LxWxH)', Value: '5000 x 2000 x 3650 mm' },
    { Parameter: 'Envelope Size (WxH)', Value: '1000 x 1250 mm' },
    { Parameter: 'Entry & Exit Cutout (WxH)', Value: '1200 x 1450 mm' },
    { Parameter: 'Manual Operator Cutout', Value: '2 no\'s' },
    { Parameter: 'Auto Guns Cutout', Value: '4 no\'s' },
    { Parameter: 'MOC', Value: 'SS-304 1.2 & 1.5 mm' },
    { Parameter: 'Base Support', Value: 'MS 3 mm & 1.5 mm' },
    { Parameter: 'Dust Collector (LxWxH)', Value: '2200 x 2200 x 5100 mm' },
    { Parameter: 'Cyclone (LxWxH)', Value: '1550 x 1550 x 5000 mm' },
    { Parameter: 'Exhaust Blower Capacity', Value: '16000 CMH' },
    { Parameter: 'Motor Rating', Value: '50 HP 3 Phase (ABB Make)' },
    { Parameter: 'MOC of Dust Collector & Cyclone', Value: 'MS 1.2mm, 2mm, 3mm, 5mm, 12mm' },
    { Parameter: 'Area Required for Oven and Booth', Value: '30000(L) x 10000(W) x 6000(H) mm' },
  ],
};

const pre_treatment_process = {
  9: {
    id: 'pre_treatment_9',
    label: '9 Tank Pre Treatment Process',
    headers: DEFAULT_HEADERS,
    data: [
      { Parameter: 'Total No of Tanks', Value: '9 no\'s' },
      { Parameter: 'MOC', Value: 'MS 3mm with steel Painted' },
      { Parameter: 'Drying Oven (LxWxH)', Value: '3150 x 2450 x 2820 mm' },
      { Parameter: 'Wall Thickness', Value: '150 mm' },
      { Parameter: 'Operating Temperature', Value: '100 deg C' },
      { Parameter: 'Rockwool', Value: '96 density' },
      { Parameter: 'Tank Size (LxWxH)', Value: '3065 x 1400 x 2820 mm' },
      { Parameter: 'Cage Size (LxWxH)', Value: '2700 x 1100 x 2600 mm' },
      { Parameter: 'Cage MOC', Value: 'SS-304' },
      { Parameter: 'Transport', Value: '1 no\'s' },
      { Parameter: 'Motors', Value: '5 HP 2 no\'s' },
      { Parameter: 'Hot Water Generator', Value: '1 no\'s' },
      { Parameter: 'Drainage and Civil Work', Value: 'Customer\'s Scope' },
      { Parameter: 'Area Required for PT Line', Value: '2500(L) x 5500(W) x 7000(H) mm' },
      { Parameter: 'Working Platform', Value: '01 no\'s' },
    ],
  },
};

const manual_gun = {
  electrical_data: {
    id: 'manual_gun_electrical',
    label: 'Electrical Data',
    headers: ['Electrical Data', 'Specifications'],
    data: [
      { Parameter: 'Rated Input Voltage / Connected Load', Value: '110-260 V AC / 150 VA' },
      { Parameter: 'Frequency', Value: '50 – 60 Hz' },
      { Parameter: 'Type of Protection', Value: 'IP 54' },
      { Parameter: 'Temperature Range', Value: '0 deg C to +40 deg C' },
    ],
  },
  pneumatical_data: {
    id: 'manual_gun_pneumatical',
    label: 'Pneumatical Data',
    headers: ['Pneumatical Data', 'Specifications'],
    data: [
      { Parameter: 'Max. Input Pressure', Value: '5.5 Bar / 80 psi' },
      { Parameter: 'Max. Water Vapor Content of Compressed Air', Value: '1.3 gms/Nm3' },
      { Parameter: 'Max. Oil Vapor Content of Compressed Air', Value: '0.1 mg/Nm3' },
      { Parameter: 'Max. Compressed Air Consumption', Value: '14 Nm3/h' },
    ],
  },
  application_data: {
    id: 'manual_gun_application',
    label: 'Application Data',
    headers: ['Application Data', 'Specifications'],
    data: [
      { Parameter: 'Type of Powder', Value: 'Standard Powder' },
    ],
  },
  operating_conditions: {
    id: 'manual_gun_operating',
    label: 'Operating Conditions',
    headers: ['Application Data', 'Specifications'],
    data: [
      { Parameter: 'Ambient Air Temperature Range', Value: '+10 to +40 [°C]' },
      { Parameter: 'Work Piece Temperature Range', Value: '+10 to +50 [°C]' },
      { Parameter: 'Air Flow / Thermal Current Near the Booth', Value: '< 0.1 [m/s]' },
    ],
    disclaimers: [
      'For approved coating powders only!',
      'Technical data of the equipment can be found in the brochures.',
    ],
  },
};

const gem_automatic_system = {
  electrical_cabinet: {
    id: 'gema_electrical_cabinet',
    label: 'OptiFlex AS10 Electrical Cabinet (Manufactured Locally)',
    technical_specification: {
      power_supply: {
        id: 'gema_power_supply',
        label: 'Power Supply',
        headers: DEFAULT_HEADERS,
        data: [
          { Parameter: 'Standard', Value: '3x400 VAC+N+PE / 50/60 Hz' },
          { Parameter: 'US Market', Value: '100-120 V 60 Hz' },
        ],
      },
      dimensions: {
        id: 'gema_dimensions',
        label: 'Technical Data',
        headers: DEFAULT_HEADERS,
        data: [
          { Parameter: 'Width', Value: '600 [mm]' },
          { Parameter: 'Depth (incl. base)', Value: '300 (550) [mm]' },
          { Parameter: 'Max Height', Value: '1\'880 [mm]' },
        ],
      },
    },
  },
  hopper: {
    id: 'gema_hopper',
    label: 'HF100 Powder Hopper (Manufactured Locally)',
    technical_specification: {
      id: 'gema_hopper_data',
      label: 'Technical Data',
      headers: DEFAULT_HEADERS,
      data: [
        { Parameter: 'Diameter', Value: '24 mm' },
        { Parameter: 'Height', Value: '600 mm' },
        { Parameter: 'Capacity', Value: '100 l' },
      ],
    },
  },
  reciprocator_control_unit: {
    id: 'gema_reciprocator_control',
    label: 'OptiMove CR08 Reciprocator Control Unit',
    technical_data: {
      id: 'gema_reciprocator_control_data',
      label: 'Technical Data',
      headers: DEFAULT_HEADERS,
      data: [
        { Parameter: 'Positioning Error', Value: '< 5 [mm]' },
      ],
    },
  },
  reciprocator: {
    id: 'gema_reciprocator',
    label: 'ZA10-18 Reciprocator',
    technical_data: {
      id: 'gema_reciprocator_data',
      label: 'Technical Data',
      headers: DEFAULT_HEADERS,
      data: [
        { Parameter: 'Height', Value: '2760 [mm]' },
        { Parameter: 'Width (base)', Value: '550 [mm]' },
        { Parameter: 'Width (column)', Value: '250 [mm]' },
        { Parameter: 'Depth', Value: '750 [mm]' },
        { Parameter: 'Stroke', Value: '1800 [mm]' },
        { Parameter: 'Speed', Value: '0.08 to 0.6 [m/s]' },
        { Parameter: 'Acceleration', Value: '0.1 – 2.0 [m/s²]' },
        { Parameter: 'Max Load', Value: '25 [kg]' },
        { Parameter: 'Power Consumption', Value: '0.4 [kVA]' },
        { Parameter: 'Max Cable Length to the CR Control', Value: '20 [m]' },
      ],
    },
  },
};

/** Default export: keyed by spec id for getSpecData(ts, key). Used by QuotationProductDetailsPages. */
const technical_specification = {
  powder_coating_curing_oven,
  batch_type_oven,
  conveyorised_camel_back_water_drying_oven,
  batch_type_water_dry_off_oven,
  wood_sublimation_oven_plc_based,
  wood_sublimation_oven_without_plc,
  over_head_conveyor,
  all_booth: common_booth_specifications,
  liquid_painting_booth,
  booth_with_reciprocator_cutout,
  four_manual_cutouts,
  two_manual_cutouts,
  single_operator,
  jumbo,
  cartridge_filter_booth,
  recovery_booth_pollution_free,
  dust_collector,
  powder_transfer_system,
  pre_treatment_process,
  manual_gun,
  gem_automatic_system,
};

/**
 * Table config keyed by main product (for form integration).
 * Use with quotationFormConfig[configKey].technicalSpecKey to get table data.
 */
export const technicalSpecTables = {
  oven: 'powder_coating_curing_oven',
  conveyor: 'over_head_conveyor',
  booth: 'recovery_booth_pollution_free',
  pt_line: 'pre_treatment_process',
  manual_gun: 'manual_gun',
  dust_collector: 'dust_collector',
  reciprocator: null,
  ...Object.keys(technical_specification).reduce((acc, key) => {
    acc[key] = key;
    return acc;
  }, {})
};

/**
 * Dynamic spec mapping for nested selections.
 * Maps product + nested selection to correct technical spec key.
 * Used when customer makes specific selections within a product category.
 */
export const dynamicSpecMapping = {
  // Oven mappings: based on selected oven type and variant
  oven: {
    powder_coating_curing_oven: 'powder_coating_curing_oven',
    batch_type_oven: 'batch_type_oven',
    wood_sublimation_oven_plc_based: 'wood_sublimation_oven_plc_based',
    wood_sublimation_oven_without_plc: 'wood_sublimation_oven_without_plc',
    conveyorised_camel_back_water_drying_oven: 'conveyorised_camel_back_water_drying_oven',
    batch_type_water_dry_off_oven: 'batch_type_water_dry_off_oven',
  },
  // Booth mappings: all booth variants except cartridge_filter_booth use all_booth spec
  booth: {
    cartridge_filter_booth: 'cartridge_filter_booth',
    all_booth: 'all_booth',
    booth_with_reciprocator_cutout: 'booth_with_reciprocator_cutout',
    four_manual_cutouts: 'four_manual_cutouts',
    two_manual_cutouts: 'two_manual_cutouts',
    single_operator: 'single_operator',
    jumbo: 'jumbo',
  },
  // Powder transfer system: material selection (ms/ss) always uses the same spec table
  powder_transfer_system: {
    ms: 'powder_transfer_system',
    ss: 'powder_transfer_system',
  },
};

/**
 * Get table data for a product: returns { label, headers, data } or null.
 * Supports dynamic mapping based on nested selections.
 * @param {Object} specs - Technical specifications object
 * @param {string} productKey - Main product key (oven, booth, etc.)
 * @param {string} selectedValue - The actual selected value (e.g., 'batch_type' for oven)
 * @returns {Object|null} - { label, headers, data } or null
 */
export function getTechnicalTable(specs, productKey, selectedValue = null) {
  const selectedKey = typeof selectedValue === 'string' ? selectedValue : selectedValue?.value;
  let tableKey = technicalSpecTables[selectedValue || productKey];
  if (selectedKey && dynamicSpecMapping[productKey]) {
    tableKey = dynamicSpecMapping[productKey][selectedKey] || tableKey;
  }
  if (!tableKey || !specs) return null;
  const spec = specs[tableKey];
  if (!spec) return null;
  if (spec.data) return { label: spec.label, headers: spec.headers, data: spec.data };
  if (tableKey === 'pre_treatment_process' && spec[9]) return { label: spec[9].label, headers: spec[9].headers, data: spec[9].data };
  return null;
}

/** Normalize table row to { label, value }. */
function toLabelValue(row) {
  const label = row?.Parameter ?? row?.parameter ?? row?.Component ?? row?.label ?? '';
  const value = row?.Value ?? row?.value ?? row?.Quantity ?? row?.quantity ?? '';
  return { label, value };
}

/**
 * Extract technical tables from a Gema component.
 * Handles: technical_specification (single or multiple sub-tables), technical_data (single).
 */
function extractTablesFromBlock(block) {
  if (!block || typeof block !== 'object') return [];
  if (block.data && Array.isArray(block.data)) {
    return [{
      id: block.id || 'single',
      label: block.label || block.title || block.text || 'Technical Data',
      headers: block.headers || DEFAULT_HEADERS,
      data: block.data.map(toLabelValue),
    }];
  }
  const tables = [];
  for (const key of Object.keys(block)) {
    if (['id', 'title', 'text', 'description', 'items', 'disclaimers'].includes(key)) continue;
    const sub = block[key];
    if (sub?.data && Array.isArray(sub.data)) {
      tables.push({
        id: sub.id || key,
        label: sub.label || sub.title || sub.text || key,
        headers: sub.headers || DEFAULT_HEADERS,
        data: sub.data.map(toLabelValue),
      });
    }
  }
  return tables;
}

/**
 * Get all technical tables for a Gema component.
 * Component can have technical_specification (single or multiple) and/or technical_data.
 */
export function getGemaComponentTechnicalTables(gemaSource, componentKey) {
  const component = gemaSource?.[componentKey];
  if (!component) return [];
  const tables = [];
  if (component.technical_specification) {
    tables.push(...extractTablesFromBlock(component.technical_specification));
  }
  if (component.technical_data) {
    tables.push(...extractTablesFromBlock(component.technical_data));
  }
  return tables;
}

/** Build options for Gema components from GEMA_Automatic_System. */
export function getGemaComponentOptions() {
  return Object.keys(GEMA_Automatic_System || {}).map((key) => ({
    value: key,
    label: GEMA_Automatic_System[key].title || GEMA_Automatic_System[key].text || key.replace(/_/g, ' '),
  }));
}

/**
 * Get all technical tables for a product that has multiple tables (e.g. manual_gun).
 * Returns array of { id, label, headers, data } with data as { label, value }[].
 */
export function getProductTechnicalTables(specs, specKey) {
  const spec = specs?.[specKey];
  if (!spec || typeof spec !== 'object') return [];
  const tables = [];
  const keys = Object.keys(spec).filter((k) => k !== 'id' && k !== 'disclaimers');
  for (const key of keys) {
    const block = spec[key];
    if (!block || typeof block !== 'object') continue;
    if (block.data && Array.isArray(block.data)) {
      tables.push({
        id: block.id || key,
        label: block.label || block.title || key,
        headers: block.headers || ['Parameter', 'Value'],
        data: block.data.map(toLabelValue),
      });
    }
  }
  return tables;
}

export default technical_specification;
export { recoveryBoothContent, pre_treatment_process_steps, GEMA_Automatic_System };
